import React, { useContext } from "react";
import { bool, oneOf, string } from "prop-types";
import AssetsProvider from "../utils/AssetsProvider";
import { classes } from "../utils/classes";
import forwardRefPropType from "../utils/forward-ref";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { sizingClassName, sizingProps, sizingPropTypes } from "../props/sizing";

const Image = ({
	isBaseUrl = true,
	forwardRef,
	src,
	alt = "",
	shadow = false,
	grayscale = false,
	invert,
	spacing = { ...spacingProps },
	utility = { ...utilityProps },
	sizing = { ...sizingProps },
	className = "",
	...props
}) => {
	const ctxBaseUrl = useContext(AssetsProvider.context);
	const baseUrl = isBaseUrl ? ctxBaseUrl : "";
	const altText = alt.trim();
	return (
		<img
			ref={forwardRef}
			className={classes(
				"image",
				shadow && "image--shadow",
				grayscale && "image--grayscale",
				invert && `image--invert-${invert}`,
				...utilityClassName(utility),
				...spacingClassName(spacing),
				...sizingClassName(sizing),
				className,
			)}
			alt={altText}
			{...props}
			src={`${baseUrl}${src}`}
		/>
	);
};

Image.propTypes = {
	forwardRef: forwardRefPropType,
	isBaseUrl: bool,
	src: string.isRequired,
	className: string,
	alt: string,
	shadow: bool,
	grayscale: bool,
	invert: oneOf(["white", "black"]),
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
	sizing: sizingPropTypes,
};

export default Image;
